import React, { useEffect, useRef, useState } from "react";
import "@styles/pages/EventForm/EventForm.scss";
import { useDispatch, useSelector } from "react-redux";
import FormPage from "@pages/EventForm/step1/FormPage";
import PreviewPage from "@pages/EventForm/step2/PreviewPage";
import ThankYouPage from "@pages/GenericPage/ThankYouPage";
import { Box } from "@mui/material";
import { resetFormStep } from "@store/ui/formStepSlice";
import useScrollToTop from "@hooks/useScrollToTop";
import { Trans, useTranslation } from "react-i18next";

const EventForm = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const currentStep = useSelector((state) => state.formStep.eventForm);
    useScrollToTop();
    useEffect(() => {
      dispatch(resetFormStep({ formKey: "eventForm" }));
    }, []);



  return (


    <Box className="event-form-container">
      {currentStep === 0 && <FormPage />}
      {currentStep === 1 && <PreviewPage />}
      {currentStep === 2 && (
        <ThankYouPage
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("form:thank_you_message_title"),
              }}
            ></span>
          }
          textList={[
            <span
              dangerouslySetInnerHTML={{
                __html: t("form:thank_you_message_description"),
              }}
            ></span>,
          ]}
        />
      )}
      {currentStep === 3 && (
        <ThankYouPage
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("form:waiting_list_message_title"),
              }}
            ></span>
          }
          textList={[
            <span
              dangerouslySetInnerHTML={{
                __html: t("form:waiting_list_message_description"),
              }}
            ></span>,
          ]}
        />
      )}
    </Box>
  );
};

export default EventForm;
